export default __webpack_public_path__ + "static/media/LinkedIn-Elogiar-Reconhecer-Colega-11.141e80ba.jpg";